// Games.jsx
import React from "react";
import { useHistory } from "react-router-dom";
import GamesNavbar from "./components/GamesNavbar";
import { useTranslation } from "react-i18next";
import DonationWheel from "../components/DonationWheel";
import { FaGamepad } from "react-icons/fa";
import "./Games.css";
import "../containers/ModalTheme.css";
import "../containers/GroupPageCards.css";
import { useScene } from "../components/scene/SceneContext";
import SceneBackground from "../components/scene/SceneBackground";

export default function Games() {
  const { t } = useTranslation();
  const history = useHistory();
  const { variant } = useScene();
  const logoSrc = `${process.env.PUBLIC_URL}/images/logo/logo.png`;

  return (
    <div className={`d-flex flex-column inner-height games-landing games-landing--${variant}`}>
      <SceneBackground effectsProps={{ preset: "games", showAnimals: true }} />
      <GamesNavbar 
        rightSlot={
          <button 
            className="btn btn-sm as-btn-soft" 
            onClick={() => history.push(`${process.env.PUBLIC_URL}/images`)}
            title="Image Resources"
          >
            📸
          </button>
        }
      />

      <div className="container-xl flex-grow-1 text-center d-flex flex-column justify-content-center games-content">
        <div className="games-hero-card as-theme">
          <div className="games-hero-top">
            <div className="games-hero-mascot" aria-hidden="true">
              <img className="games-hero-logo" src={logoSrc} alt="" />
            </div>
          </div>
          <h1 className="games-title">
            <span className="games-typing">AnimalSplit</span>
            <span className="games-badge">
              <FaGamepad className="games-badge-icon" />
              <span className="games-badge-text">{t("games.landing.title_suffix")}</span>
            </span>
          </h1>
          <div className="games-emoji-row" aria-hidden="true">🎮🎲🎯🃏🎰🎪 🌿🌳</div>
          <p className="games-slogan">{t("games.landing.slogan")}</p>
          <div className="games-cta-row">
            <button
              className="btn btn-lg as-btn-primary-gradient"
              onClick={() => history.push(`${process.env.PUBLIC_URL}/games/categories`)}
            >
              {t("games.landing.browse_games")}
            </button>
          </div>
        </div>
      </div>
      <DonationWheel />
    </div>
  );
}
